import React from 'react'
import { useMutation, useQuery } from 'react-apollo'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

import useServerError from '../../../src/hooks/useServerError'
import { Form, FormIdentifier } from '../forms/FieldFactory'
import FormBuilder from '../../components/forms/FormBuilder'
import RequestTwofaToken from '../../graphql/RequestTwofaToken.gql'
import VerifyTwofaTokenMutation from '../../graphql/VerifyTwofaTokenMutation.gql'
import {
  BasicType,
  ElementType,
} from '../../../src/components/forms/FormElementParts'
import { FormData } from '../../../src/components/forms/FormCollector'

const form: Form = {
  fields: [
    {
      label:
        'Your authentication code has been sent to the phone number on file. Please enter the code below to log in.',
      type: BasicType.PLAINTEXT,
    },
    {
      icon: 'Lock',
      label: 'Token',
      name: 'token',
      type: ElementType.TEXT,
    },
    {
      label: 'Verify Token',
      type: BasicType.SUBMIT,
    },
  ],
  header: 'Verify Token',
  type: FormIdentifier.VERIFY_TOKEN,
}

export default () => {
  const location = useLocation()
  const credentialId = (location.state as any)?.credentialId
  const [verifyToken, { data, error }] = useMutation(VerifyTwofaTokenMutation)
  const { error: twofaError } = useQuery(RequestTwofaToken, {
    variables: { credentialId },
  })
  const { clearServerError, serverError, setServerError } = useServerError()
  const handleSubmitForm = React.useCallback(
    (formData: FormData) => {
      verifyToken({
        variables: {
          ...formData,
          credentialId,
        },
      })
    },
    [credentialId, verifyToken],
  )
  React.useEffect(() => {
    if (error && error.graphQLErrors.length) {
      const err: any = error.graphQLErrors[0]
      setServerError({ message: err.message, errors: err.fields })
    } else if (twofaError && twofaError.graphQLErrors.length) {
      const err: any = twofaError.graphQLErrors[0]
      setServerError({ message: err.message, errors: err.fields })
    } else {
      clearServerError()
    }
  }, [clearServerError, error, setServerError, twofaError])
  const verifyTokenData = data && data.verifyTwofaToken
  if (verifyTokenData) {
    window.location.href = '/'
  }

  return (
    <React.Fragment>
      <Helmet
        title={`${(window as any).CMD.config.tenant.page_title} - Verify Token`}
      />
      <FormBuilder
        form={form}
        key={form.type}
        onChange={clearServerError}
        onSubmit={handleSubmitForm}
        serverError={serverError}
      />
    </React.Fragment>
  )
}
